import { useMemo } from "react";
import moment from "moment";
import s from "./FromPeriodChooser.module.scss";

const getPeriods = (minDate: string) =>
  [
    { label: "1W", value: moment().subtract(1, "weeks").format("YYYY-MM-DD") },
    { label: "MTD", value: moment().startOf("month").format("YYYY-MM-DD") },
    { label: "1M", value: moment().subtract(1, "months").format("YYYY-MM-DD") },
    { label: "3M", value: moment().subtract(3, "months").format("YYYY-MM-DD") },
    { label: "6M", value: moment().subtract(6, "months").format("YYYY-MM-DD") },
    { label: "YTD", value: moment().startOf("year").format("YYYY-MM-DD") },
    { label: "1Y", value: moment().subtract(1, "years").format("YYYY-MM-DD") },
    { label: "3Y", value: moment().subtract(3, "years").format("YYYY-MM-DD") },
    { label: "5Y", value: moment().subtract(5, "years").format("YYYY-MM-DD") },
  ].filter((period) => moment(period.value).isSameOrAfter(minDate));

export const FromPeriodChooser = ({
  setFromDate,
  fromDate,
  minDate,
  stuckPeriod,
}: {
  setFromDate: (date: string) => void;
  fromDate: string;
  minDate: string;
  stuckPeriod?: string;
}) => {
  const periods = useMemo(() => getPeriods(minDate), [minDate]); // Calculate periods when minDate changes
  return (
    <div className={s.row}>
      {periods.map((period) => {
        return (
          <button
            key={period.value}
            className={`${s.periodButton} ${
              stuckPeriod
                ? period.label === stuckPeriod
                  ? s.selected
                  : ""
                : fromDate === period.value
                ? s.selected
                : ""
            }`}
            onClick={() => !stuckPeriod && setFromDate(period.value)}
            disabled={!!stuckPeriod}
          >
            {period.label}
          </button>
        );
      })}
    </div>
  );
};
